<form novalidate [formGroup]="lobbyImpersonateForm">


<kendo-dialog title="{{header}}" *ngIf="dialogOpened" (close)="close('dialog')" [minWidth]="300" [width]="630">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
    <p>{{message}}</p>
    <div class="d-flex mt-3 align-items-center">
      
        <label class="me-3">
          {{'_Lobby_Impersonate_Assist_As_Text_' | translate}}
        </label>     
        <select class="cc-select-dropdown form-control w-75" id="assistAsUser" placeholder="Select"
        formControlName="assistAsUser">
        <option value="-1">{{'_Lobby_Impersonate_Select_User_Text_' | translate}}</option>
        <option *ngFor="let user of userDetails" [ngValue]="user.userId">
          {{ user.firstName }} {{ user.lastName }}
        </option>
      </select>
      
     
    </div>
  
  
    <kendo-dialog-actions  class="cc-btn-panel">
      <button class="btn btn-secondary" (click)="emitCancel('no')">{{actionNoLabel}}</button>
      <button class="btn btn-primary"  [disabled]="lobbyImpersonateForm.invalid || lobbyImpersonateForm.pristine" (click)="emitSubmit('yes')" primary="true">{{actionYesLabel}}</button>
    </kendo-dialog-actions>
  </kendo-dialog>
  
  <kendo-dialog title="{{'_Lobby_Impersonate_Unable_To_Assist_Text_' | translate}}" *ngIf="unableToImpersonate" (close)="closeUnableToImpersonate()" [minWidth]="300" [width]="630">
    <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
    <p>{{'_Lobby_Impersonate_Assist_No_User_Text_' | translate}}</p>
   
  
  
    <kendo-dialog-actions  class="cc-btn-panel">     
      <button class="btn btn-primary"   (click)="closeUnableToImpersonate()"  primary="true">{{'_General_Button_Ok_Text_' | translate}}</button>
    </kendo-dialog-actions>
  </kendo-dialog>
  <kendo-dialog title="{{'_General_Different_Person_Requested_Text_' | translate}}" *ngIf="showDifferentPersonRequested" (close)="closeDifferentPersonRequestedPopup()" [minWidth]="300" [width]="630">
    <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
    <p>{{'_Lobby_Impersonate_Person_Request_Text_' | translate}} '{{lobbyEntry.personRequested}}'{{'_Lobby_Impersonate_Want_Assist_Text_' | translate}}</p>
   
  
  
    <kendo-dialog-actions  class="cc-btn-panel">  
      <button class="btn btn-secondary" (click)="closeDifferentPersonRequestedPopup()">{{'_General_Action_Label_No_Text_' | translate}}</button>   
      <button class="btn btn-primary"   (click)="impersonateAssist()"  primary="true">{{'_General_Action_Label_Yes_Text_' | translate}}</button>
    </kendo-dialog-actions>
  </kendo-dialog>
</form>
